import {
  Conversation,
  StripeAssistantLiveAnswersResponse,
} from '@stripe-internal/conversations-client';
import {LiveAnswersResponse} from '../../StripeAssistant/LiveAnswersV2/LiveAnswersResponse';

type Props = {
  conversation: Conversation;
  messageId: string;
  data: StripeAssistantLiveAnswersResponse;
  onDone: () => void;
  isDone?: boolean;
};

export const LiveAnswersRow = ({
  conversation,
  messageId,
  data,
  onDone,
  isDone,
}: Props) => {
  return (
    <LiveAnswersResponse
      conversation={conversation}
      messageId={messageId}
      llmConversationId={data.llm_conversation_id}
      cacheUuid={data.cache_uuid}
      sources={data.sources}
      cachedContent={data.is_streamed ? data.content : null}
      isDone={isDone}
      onComplete={() => {
        onDone();
      }}
    />
  );
};
